import { useSelector } from "react-redux";
import { RootState } from "../ducks";
import { Location } from "../queries/auto-generated/schemas";

const useCurrentLocation = () => {
  const {
    selected,
    data: { locations },
    error,
    loading,
  } = useSelector((state: RootState) => state.location);
  let current: Location | undefined = undefined;

  if (!error && !loading && selected && locations && locations[selected]) {
    current = locations[selected];
  }

  return {
    current,
    locations,
  };
};


export default useCurrentLocation